import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopPayment = dynamic(() => import("../components/payment/DesktopPayment"), {
  loading: () => <Loading />
})

const MobilePayment = dynamic(() => import("../components/payment/MobilePayment"), {
  loading: () => <Loading />
})

const payment = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>QueueBuster POS: Stop Saying No to Any Payment Type</title>
        <meta name="description" content="Accept any payment! QueueBuster POS integrates seamlessly with all major payment brands." />
        <link rel="canonical" href="https://queuebuster.co/pos-payment-partners" />
        <link rel="alternate" href="https://queuebuster.co/pos-payment-partners" hrefLang="en-us" />
        <meta property="og:title" content="QueueBuster POS: Stop Saying No to Any Payment Type" />
        <meta property="og:description" content="Accept any payment! QueueBuster POS integrates seamlessly with all major payment brands." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/payment.jpg" />
        <meta property="og:url" content="https://queuebuster.co/pos-payment-partners" />
      </Head>
      {
        mobileView ? <MobilePayment /> : <DesktopPayment />
      }
    </>
  )
}

export default payment